import React from "react";
import Attendance from "../../components/Attendance/attendance.component";

export default class AttendanceScreen extends React.Component {
  render() {
    return <Attendance />;
  }
}
